import { SearchWidgetSkeleton, SearchWidgetSkeletonFieldInterface } from './search-widget-skeleton';

export interface FlightSearchWidgetSkeletonProps {
	isFadingOut?: boolean;
}

const flightSearchFields: SearchWidgetSkeletonFieldInterface[] = [
	{ id: 'trip-type', flex: 0.8, minWidth: 100 },
	{ id: 'origin', flex: 1.4, minWidth: 150 },
	{ id: 'destination', flex: 1.4, minWidth: 150 },
	{ id: 'dates', flex: 1.4, minWidth: 150 },
	{ id: 'passengers', flex: 1.2, minWidth: 140 },
];

export function FlightSearchWidgetSkeleton({ isFadingOut }: Readonly<FlightSearchWidgetSkeletonProps>): JSX.Element {
	return <SearchWidgetSkeleton testIdPrefix='flights-search.widget' fields={flightSearchFields} isFadingOut={isFadingOut} />;
}

export default FlightSearchWidgetSkeleton;
